import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAllAdminNavMenus = async (params = {}) => {
    if (!params.languageCode) params.languageCode = 'vi';
    if (!params.pageSize) params.pageSize = 1000;
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.NAV_MENUS.GET_ALL, { params });
    return response.data;
};

export const getAdminNavMenuById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.NAV_MENUS.GET_BY_ID(id));
    return response.data;
};

export const getPublicNavMenusByLanguage = async (languageCode = 'vi') => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.NAV_MENUS.GET_PUBLIC(languageCode));
    return response.data;
};

export const createNavMenu = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.NAV_MENUS.CREATE, data);
    return response.data;
};

export const updateNavMenu = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.NAV_MENUS.UPDATE(id), data);
    return response.data;
};

export const deleteNavMenu = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.NAV_MENUS.DELETE(id));
    return response.data;
};
